import { render } from "./PlanningInspire.vue?vue&type=template&id=825d71e4&scoped=true"
import script from "./PlanningInspire.vue?vue&type=script&lang=js"
export * from "./PlanningInspire.vue?vue&type=script&lang=js"

import "./PlanningInspire.vue?vue&type=style&index=0&id=825d71e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825d71e4"]])

export default __exports__